/**
 * Human-readable feed / data source labels for inventory publish preview UI.
 */
export function formatFeedSource(source: string): string {
  const raw = String(source || '').trim()
  const normalized = raw.toLowerCase().replace(/^import_/, '')
  if (normalized === 'vauto') return 'vAuto'
  if (normalized === 'homenet') return 'HomeNet'
  if (normalized === 'fdds1' || normalized === 'fdds2' || normalized === 'fdds2' || normalized === 'fdds') return 'FDDS'
  if (normalized === 'dealerslink') return 'DealersLink'
  if (normalized === 'chrome_cvd_1_0' || normalized === 'chrome_cds_v1' || normalized === 'chrome') {
    return 'Chrome'
  }
  if (normalized === 'manual_add' || normalized === 'custom_feed') return 'Manual add'
  return raw || 'Selected'
}
